import { Button as ButtonStyle } from './styles'

export type Props = {
  children: string | JSX.Element
  width?: 'all'
}

const Button = ({ children }: Props) => {
  return <ButtonStyle>{children}</ButtonStyle>
}

export default Button
